let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c1PYg")).then(() => parcelRequire('6Odzi'));